import { useMemo, useEffect, useState, useCallback } from 'react';
import { SearchAPIReturnedProposal, TeacherDetails } from './types';
import { createTeacherSearchAPIURL } from '../search/searchApi';
import { LoadingEllipsis } from '../common/LoadingEllipsis';
import { FundedProjectList } from '../common/FundedProjectList';
import { getIndex, getPage } from '../common/requestUtils';
import { Pagination } from '../common/pagination';

interface TeacherProfilePreviousProjectsBarProps {
    teacherDetails: TeacherDetails,
}

const MAX_ELEMENTS_PER_PAGE = 3;

const TeacherProfilePreviousProjectsBar = ({
    teacherDetails,
}: TeacherProfilePreviousProjectsBarProps) => {
    const hasFundedProjects = teacherDetails.numFundedProjects > 0;
    const [fundedProjects, setFundedProjects] = useState<SearchAPIReturnedProposal[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [totalProposals, setTotalProposals] = useState<number>(0);
    const isMobileView = useMemo(() => {
        return window.isMobileView();
    }, []);

    const getFundedProjects = useCallback((url: string) => {
        setIsLoading(true);
        const page = getPage(url);
        setPage(page);

        const index = getIndex(url, MAX_ELEMENTS_PER_PAGE);
        $.ajax({
            type: 'GET',
            url: createTeacherSearchAPIURL(teacherDetails.id, index, null, MAX_ELEMENTS_PER_PAGE, true),
            dataType: 'json',
            success: (response) => {
                const fundedProposals = response.proposals;

                setTotalProposals(parseInt(response.totalProposals));
                setFundedProjects(fundedProposals);
                setIsLoading(false);
            },
            error: () => {
                setIsLoading(false);
            },
        });
    }, [teacherDetails.id]);

    useEffect(() => {
        if (!hasFundedProjects) {
            return;
        }
        getFundedProjects(location.href);
    }, [hasFundedProjects, getFundedProjects]);

    if (!hasFundedProjects) {
        return null;
    }

    const renderPagination = function () {
        if (fundedProjects && fundedProjects.length > 0) {
            return <Pagination max={totalProposals}
                showNextButton={true}
                page={page}
                perPage={MAX_ELEMENTS_PER_PAGE}
                isLoading={isLoading}
                changeURL={getFundedProjects}
                simplePagination={isMobileView}/>;
        }
    };

    return (<div className="project-section-contents">
        {isLoading ? <div className="teacher-requests-loading"><LoadingEllipsis/></div> : <FundedProjectList projects={fundedProjects}/>}
        {renderPagination()}
    </div>
    );
};

export default TeacherProfilePreviousProjectsBar;
